'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';
import { Icon } from '../icon/icon.component.js';

const SelectionSetError = renderWithRef('SelectionSetError', null, (t, n)=>jsxs(RenderComp, {
        root: "p",
        forwardedRef: n,
        classNames: [
            'swan-selection-set-error'
        ],
        props: t,
        children: [
            jsx(Icon, {
                iconType: "error",
                skin: "error",
                alt: ""
            }),
            t.children
        ]
    }));

export { SelectionSetError };
